import type * as React from 'react';

import { useTranslation } from 'react-i18next';

import { FullPageSpinner } from '@/components/FullPageSpinner';

// Rendered while react-oidc-context is processing the OIDC redirect.
// `onSigninCallback` in oidcConfig.ts rewrites history back to `/` after
// the code exchange, so this page is short-lived.
export const CallbackPage = (): React.JSX.Element => {
  const { t } = useTranslation('auth');
  return <FullPageSpinner label={t('callback.processing')} />;
};
